import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import { useClipboard } from 'use-clipboard-copy';
import { Tooltip, TooltipPlacement, TooltipSize } from '../../../Tooltip';
import { COPY_CHANGE_TEXT_TIME } from '@eva-pacs/core';
/**
 * Title and Description Cell (Table)
 * @author Sergio Ruiz Davila<sergioruizdavila@gmail.com>
 * Created at 2021-07-27
 */
export var TitleDescriptionCell = function (_a) {
    var title = _a.title, titleHref = _a.titleHref, _b = _a.titleExternalLink, titleExternalLink = _b === void 0 ? false : _b, titleOnClick = _a.titleOnClick, description = _a.description, descriptionPrefix = _a.descriptionPrefix, _c = _a.isCopiedDescription, isCopiedDescription = _c === void 0 ? false : _c, className = _a.className;
    var cellClass = cn(className, 'inline-flex flex-col');
    var t = useTranslation().t;
    var clipboard = useClipboard({ copiedTimeout: COPY_CHANGE_TEXT_TIME });
    var renderTitle = function () {
        if (titleHref && titleExternalLink)
            return (React.createElement("a", { className: "inline-flex mb-1 text-basic-white underline text-caption", href: titleHref, target: "_blank", rel: "noreferrer" }, title));
        if (titleHref && !titleExternalLink)
            return (React.createElement(Link, { className: "inline-flex mb-1 text-basic-white underline text-caption", to: titleHref }, title));
        if (titleOnClick)
            return (React.createElement("button", { className: "inline-flex mb-1 text-left text-basic-white underline text-caption", onClick: titleOnClick }, title));
        return React.createElement("span", { className: "inline-flex mb-1 text-basic-white text-caption" }, title);
    };
    var renderDescription = function () {
        if (description && isCopiedDescription)
            return (React.createElement(Tooltip, { className: "inline-flex", text: clipboard.copied ? "\u00A1".concat(t('general.copied'), "!") : "".concat(t('general.copy')), size: TooltipSize.sm, placement: TooltipPlacement.top, hasArrow: false },
                React.createElement("span", { role: "button", tabIndex: -1, className: "inline-flex hover:text-light-gray-300 text-light-gray-600 text-caption font-regular", onClick: function () { return clipboard.copy(description); }, onKeyPress: function () { return clipboard.copy(description); } },
                    descriptionPrefix,
                    description)));
        if (description && !isCopiedDescription)
            return (React.createElement("span", { className: "text-light-gray-600 text-caption font-regular" },
                descriptionPrefix,
                description));
        return React.createElement(React.Fragment, null);
    };
    return (React.createElement("div", { className: cellClass },
        renderTitle(),
        renderDescription()));
};
